import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import ReceiptComponent from '../components/receipt.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectBankConfigurationsListItems } from '../../../../../../redux/bank-configurations/selector';
import { bankConfigurations } from '../../../../../../redux/bank-configurations/action';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import { accountLedgers } from '../../../../../../redux/account-ledgers/action';
import { selectAccountLedgersListItems } from '../../../../../../redux/account-ledgers/selector';
import { grns } from '../../../../../../redux/grns/action';
import { selectGrnsListItems } from '../../../../../../redux/grns/selector';
import { selectSuppliersListItems } from '../../../../../../redux/suppliers/selector';
import { suppliers } from '../../../../../../redux/suppliers/action';
import { selectReceiptsQueryItems } from '../../../../../../redux/fms/receipts/selector';
import { receipts } from '../../../../../../redux/fms/receipts/action';

const ManagementReceipt = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const receiptsQueryData = useSelector(selectReceiptsQueryItems)
  const libraryItemsData = useSelector(selectListItems)
  const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)
  const accountledgersItems = useSelector(selectAccountLedgersListItems)
  const grnsListItems = useSelector(selectGrnsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedReceipts, setSelectedReceipts] = useState<any>([])

  const fetchReceiptsQueryById = () => {
    dispatch(receipts.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/receipts/query`,
      entity: 'receipts',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedReceipts({ ...selectedReceipts, [field]: event });
  }

  useEffect(() => {
    dispatch(organizationUnits.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,
      entity: 'organizationUnits',
      jsonData: {}
    })).then(() => {
      dispatch(accountLedgers.list({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
        entity: 'accountLedgers',
        jsonData: {}
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchReceiptsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  const fetchInvoiceNumberListByLedgersId = (ledgerId) => {
    dispatch(grns.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/scm/e-procurement/grns/invoice-numbers`,
      entity: 'grns',
      jsonData:
      {
        Records: [
          {
            LedgerId: ledgerId
          }
        ]
      }
    }))
  }

  useEffect(() => {
    if (selectedReceipts?.LedgerId) {
      fetchInvoiceNumberListByLedgersId(selectedReceipts.LedgerId);
    }
  }, [selectedReceipts?.LedgerId]);

  useEffect(() => {
    if (isQuery) {
      setSelectedReceipts(receiptsQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(receipts.resetAction({ actionType: 'update' }))
      await dispatch(receipts.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/receipts`,
        entity: 'receipts',
        jsonData:
        {
          Records: [
            {
              ...selectedReceipts
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(receipts.resetAction({ actionType: 'create' }))
      await dispatch(receipts.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/receipts`,
        entity: 'receipts',
        jsonData:
        {
          Records: [
            {
              ...selectedReceipts
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/receipts')
  }

  return (
    <>
      {receiptsQueryData?.isLoading ? <PageLoader /> :
        <ReceiptComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedReceipts={selectedReceipts}
          back={back}
          handleFormSubmit={handleFormSubmit}
          voucherTransactionTypeList={libraryItemsData?.result?.VoucherTransactionType}
          paymentTransactionTypeList={libraryItemsData?.result?.PaymentTransactionType}
          ledgerTransactionTypeList={libraryItemsData?.result?.LedgerTransactionMethod}
          organizationUnitsList={organizationUnitsItems?.result?.items}
          ledgersList={accountledgersItems?.result?.items}
          invoiceNumbersList={grnsListItems?.result?.items}
        />
      }
    </>
  )
}

export default ManagementReceipt;